import { LinkProvider } from '@ds/components/actions/LinkRouter';
import useAppNavigate from '@effects/useAppNavigate';
import React from 'react';
import { useHref } from 'react-router-dom';

/**
 * Connects the router-agnostic `Link` to this app's React Router: `useAppNavigate` for client-side navigation, and
 * React Router's own `useHref`, which applies the router's basename to the rendered `href`. Mount it inside `<Router>`.
 *
 * A link to the URL you are already on pushes a new history entry, where React Router's own `<Link>` would replace
 * it. No page in the app has such a link today; if one is added, pass `{ replace: true }` for that case here.
 */
const RouterLinkBridge: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const navigate = useAppNavigate();

    return (
        <LinkProvider
            navigate={navigate}
            useHref={useHref}
        >
            {children}
        </LinkProvider>
    );
};

RouterLinkBridge.displayName = 'RouterLinkBridge';

export default RouterLinkBridge;
